export default {"src":"/_next/static/media/eth.a2c182fc.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};